module.exports = __webpack_public_path__ + "static/img/apply-birth.94c84bff.png";